<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="ch00_fm05_ded"></a><a id="page_v"></a><em>In memory of my parents, A. Norman and Grace L. Heath</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_ded.vue?4a57c363